import React from 'react';
import { StyledDropMarker } from './StyledDropMarker';

export const DropMarker = () => {
  return <StyledDropMarker />;
};
